import { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import Layout from './Layout';

const CompanyListing = () => {
    const loaderData = useLoaderData() as any;
    const [companyList, setCompanyList] = useState<any[]>(loaderData?.data?.companyList ?? []);
    const [searchCriteria, setSearchCriteria] = useState<any>(loaderData?.data?.searchCriteria ?? {});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout
            companyList={companyList}
            searchCriteria={searchCriteria}
            setCompanyList={setCompanyList}
            setSearchCriteria={setSearchCriteria}
        />
    );
};

export default CompanyListing;
